import { Injectable } from '@angular/core';
import { SnackService } from './snack.service';
import { NGXLogger as LoggerService } from "ngx-logger";

@Injectable({
    providedIn: 'root'
})
export class UIMesageService {

    constructor(
        private snack: SnackService,
        private logger: LoggerService,
    ) {

    }

    success(message: string, title?: string, verticalPositionBigScreen?: "top" | "bottom") {
        this.logger.log(message, title);
        this.snack.open(message, this.snack.config('success'), null, verticalPositionBigScreen);
    }

    info(message: string, title?: string, verticalPositionBigScreen?: "top" | "bottom") {
        this.logger.log(message, title);
        this.snack.open(message, this.snack.config('info'), null, verticalPositionBigScreen);
    }

    /**
     * An info that follows the snackbar currently shown instead of replacing it, and stays longer (15 s) -
     * for a hint the user should still see after the outcome message, such as "new account created for …"
     * after a code login (code auth P3, E3).
     */
    infoFollowUp(message: string, durationMs = 15000) {
        this.logger.log(message);
        this.snack.openAfterCurrent(message, this.snack.config('info'), durationMs);
    }
    warning(message: string, title?: string, verticalPositionBigScreen?: "top" | "bottom") {
        this.logger.warn('UI warning  message:' + message, title)
        this.logger.warn(message, title);
        this.snack.open(message, this.snack.config('warning'), null, verticalPositionBigScreen);
    }

    /**
     * Shows the error snackbar and reports the error to the logger.
     * @param options.skipLog - set by callers that already logged the error with more detail,
     *   so that one failed attempt does not produce two server reports
     */
    error(error: Error, uiMessage?: string, options?: { skipLog?: boolean }) {
        this.snack.open(uiMessage ? uiMessage : error.message, this.snack.config('error'), null);
        if (options?.skipLog) return;
        if (uiMessage) {
            this.logger.warn('UI error message: ' + uiMessage)
        }
        this.logger.error(error);
    }

    dismiss() {
        this.snack.dismiss();
    }

}
